import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="nav-logo" style={{ fontSize: '1.5rem' }}>
              MARK<span style={{ color: '#FFFFFF' }}>.</span>
            </Link>
            <p>
              Transformamos marcas a través de estrategia, diseño y tecnología.
              Tu visión, nuestra ejecución.
            </p>
          </div>

          <div className="footer-col">
            <h4>Navegación</h4>
            <Link to="/">Inicio</Link>
            <Link to="/nosotros">Nosotros</Link>
            <Link to="/servicios">Servicios</Link>
            <Link to="/portafolio">Portafolio</Link>
          </div>

          <div className="footer-col">
            <h4>Contacto</h4>
            <a href="mailto:hola@markagencia.com">hola@markagencia.com</a>
            <a href="tel:+5215512345678">+52 55 1234 5678</a>
            <Link to="/contacto">Escríbenos</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} MARK. Todos los derechos reservados.</p>
          <p>Hecho con pasión en LATAM</p>
        </div>
      </div>
    </footer>
  );
}
